import { render, staticRenderFns } from "./RecordUploadPortalPage.vue?vue&type=template&id=6b5fcef0&scoped=true"
import script from "./RecordUploadPortalPage.vue?vue&type=script&lang=js"
export * from "./RecordUploadPortalPage.vue?vue&type=script&lang=js"
import style0 from "./RecordUploadPortalPage.vue?vue&type=style&index=0&id=6b5fcef0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5fcef0",
  null
  
)

export default component.exports